<div *ngIf="profile" class="text-center">
  <app-user-picture-preview
    [profile]="profile"
    [firstName]="firstName"
    [lastName]="lastName"
  ></app-user-picture-preview>

  <div *ngIf="profile[userMetadata]?.picture">
    <button class="btn btn-link" (click)="deleteAvatar()">Delete</button>
  </div>

  <div *ngIf="!profile[userMetadata]?.picture" class="mt-3">
    <form id="form" #form method="post" action="" enctype="multipart/form-data">
      <div class="uploader-wrapper">
        <dx-file-uploader
          id="user-pic-upload"
          [multiple]="false"
          [(value)]="userPicture"
          labelText=""
          accept="image/*"
          uploadMode="useForm"
          [allowedFileExtensions]="['.jpg', '.jpeg', '.png']"
          selectButtonText="Choose Profile Picture"
        >
        </dx-file-uploader>
      </div>
      
      <div class="allowed-extensions mb-3">Allowed: .jpg, .png</div>

      <dx-button
        *ngIf="userPicture.length == 1"
        text="Update"
        type="default"
        [width]="140"
        height="40px"
        (onClick)="uploadAvatar()"
      ></dx-button>
    </form>
  </div>
</div>
